import { configureStore } from "@reduxjs/toolkit";
import rootReducer from './rootReducer';
import themeReducer from './themeSlice'; 
import queryBuilderReducer from './queryBuilderSlice'; 
import queryMetaReducer from './queryMetaSlice';
import userReducer from './userSlice';
import findFleetReducer from './findFleetSlice';
import mapReducer from './mapSlice';
import notificationReducer from './notificationSlice';
import folderReducer from './folderSlice';
import saveReducer from './saveSlice';
import shareReducer from './shareSlice';
import admin  from './adminSlice';
import dashboardReducer from './dashboardSlice';
import exportReducer from './exportSlice';
import subscribeReducer from './subscribeSlice';

const store = configureStore({
    reducer: {
        theme: themeReducer,
        queryBuilder: queryBuilderReducer,
        meta: queryMetaReducer,
        user: userReducer,
        findFleet: findFleetReducer,
        map: mapReducer,
        notification: notificationReducer,
        folder: folderReducer,
        save: saveReducer,
        share: shareReducer,
        admin: admin,
        dashboard: dashboardReducer,
        export: exportReducer,
        subscribe: subscribeReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these actions or paths in the state
                ignoredActions: [
                    'findFleet/fetchFilterValues/fulfilled', // Example action type
                    'findFleet/applyFilters/fulfilled',
                ],
                ignoredPaths: ['findFleet.filtered.dispatchEvent'], // Example path
            },
        }),
});

// Define the type of the root state
export type RootState = ReturnType<typeof store.getState>;

// Define the type for the AppDispatch
export type AppDispatch = typeof store.dispatch;

export default store;


